export class ProducerSettings {
  id!: number;
  timezoneJson!: string;
  message!: string;
  timezoneStore!: TimezoneStore;
  companyId!: number | string;
}

export class TimezoneStore {
  timezones!: any[];
}

export class TimezoneBinding {
  cityId!: number;
  countryId!: number;
  countryName!: string;
  cityName!: string;
  timezone!: string;
  timezoneName!: string;
}
